import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Layers, RefreshCw } from 'lucide-react';
import { useStepCycle } from '../../hooks/useStepCycle';
const rows = [['Benutzer', 'Aufträge', 'Lager'], ['ERP', 'Mobil'], ['Reports', 'Ausbau']];
export function FoundationIllustration() {
  const total = rows.flat().length;
  const step = useStepCycle(total + 2, 850);
  const visible = Math.min(step, total);
  let index = 0;
  return <div className="absolute inset-0 p-6 xl:p-8 flex flex-col" data-id="element-31" data-mp="9owids5wotg4">
      <div className="flex items-center justify-between" data-id="element-32" data-mp="ekv4f93rhzdd">
        <span className="bg-white rounded-full px-4 py-2 text-sm font-medium text-primary shadow-sm" data-id="element-33" data-mp="3w2ebyso2c7ro">
          Release {Math.max(visible, 1)}
        </span>
        <span className="bg-white rounded-full px-4 py-2 text-sm font-medium text-primary shadow-sm flex items-center gap-2" data-id="element-34" data-mp="4uijvgvy6678">
          <motion.span className="flex" animate={{
          rotate: 360
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-35" data-mp="sjuo02cf3o2o">
            <RefreshCw className="w-4 h-4" data-id="element-36" data-mp="1k3bosyf0rggg" />
          </motion.span>
          Prozesse entwickeln sich weiter
        </span>
      </div>

      <div className="flex-1 flex flex-col-reverse items-center gap-2 pt-4" data-id="element-37" data-mp="1tsliujtfb977">
        <div className="w-full max-w-md h-14 bg-primary rounded-xl text-white font-semibold flex items-center justify-center gap-2 shrink-0" data-id="element-38" data-mp="1tuoilvkdogp4">
          <Layers className="w-5 h-5 text-accent" data-id="element-39" data-mp="22sqp2qmvs1js" />
          Fundament · modulare Architektur
        </div>
        {rows.map((row, ri) => <div key={ri} className="flex gap-2 justify-center" data-id="element-40" data-mp="1xu700hczq9n7" data-mpi={ri}>
            {row.map(label => {
          const i = index++;
          const shown = i < visible;
          const newest = i === visible - 1;
          return <div key={label} className="relative w-24 xl:w-28 h-11 xl:h-12 rounded-lg border-2 border-dashed border-primary/10" data-id="element-41" data-mp="id6lhexayfbk">
                  <AnimatePresence data-id="element-42" data-mp="1330ry3wyzp86">
                    {shown && <motion.div initial={{
                y: -70,
                opacity: 0
              }} animate={{
                y: 0,
                opacity: 1
              }} exit={{
                opacity: 0,
                transition: {
                  duration: 0.15
                }
              }} transition={{
                type: 'spring',
                stiffness: 480,
                damping: 30
              }} className={`absolute -inset-0.5 rounded-lg flex items-center justify-center text-xs xl:text-sm font-semibold transition-colors duration-300 ${newest ? 'bg-accent text-primary' : 'bg-primary-light text-white'}`} data-id="element-43" data-mp="134u23t6skrkx">
                        {label}
                      </motion.div>}
                  </AnimatePresence>
                </div>;
        })}
          </div>)}
      </div>
    </div>;
}